"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const units_service_1 = require("./units.service");
class JurisdictionService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrlV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getJurisdictionUnits(legacyUnitId) {
        const response = await this.httpService.get(`${this.endpointV2}/jurisdiction-units?filter[unit_id]=${legacyUnitId}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getJurisdiction(jurisdictionId) {
        const response = await this.httpService.get(`${this.endpointV2}/jurisdictions/${jurisdictionId}?include=jurisdiction_type`, {
            headers: this.getHeaders(),
        });
        return { data: response.data.data, included: response.data.included };
    }
    async getJurisdictionTypes() {
        const response = await this.httpService.get(`${this.endpointV2}/jurisdiction-types`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async deleteJurisdiction(juridictionId) {
        try {
            await this.httpService.delete(`${this.endpointV2}/jurisdiction-units/${juridictionId}`, {
                headers: this.getHeaders(),
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    async syncJurisdiction(legacyUnitId) {
        const syncPayload = {
            data: {
                type: "jurisdiction_unit_sync",
                attributes: {
                    unit_ids: [legacyUnitId]
                }
            }
        };
        const response = await this.httpService.post(`${this.endpointV2}/jurisdiction-units/sync`, syncPayload, { headers: this.getHeaders() });
        return response.status == 201 ? true : false;
    }
}
exports.JurisdictionService = JurisdictionService;
//# sourceMappingURL=jurisdiction.service.js.map